import { debounce } from 'lodash';

const DELAY_TIME = 250;

export const searchUtil = (callback: (searchVal: string) => void) =>
  debounce(callback, DELAY_TIME);

